import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import MegaMenuCard from "./MegaMenuCard";

const MegaMenu = ({ productsData, isArabic, isMenuOpen }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (isMenuOpen && menuRef.current) {
      gsap.fromTo(
        menuRef.current,
        { opacity: 0, y: -10, scale: 0.98 },
        { opacity: 1, y: 0, scale: 1, duration: 0.4, ease: "power3.out" }
      );
      
      gsap.fromTo(
        ".mega-card",
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, stagger: 0.05, duration: 0.4, ease: "power2.out", delay: 0.1 }
      );
    }
  }, [isMenuOpen]);

  // Flatten categories from all brands just in case we only want to show X amount or something,
  // but for now we'll just render them identically.
  const categories = productsData?.flatMap(brand => brand.categories) || [];

  return (
    <div className="relative h-full w-full">
      {isMenuOpen && (
        <div 
          ref={menuRef}
          className="h-full w-full bg-white/95 backdrop-blur-xl border border-gray-100 rounded-2xl shadow-2xl p-6 z-50 overflow-hidden"
          dir={isArabic ? 'rtl' : 'ltr'}
        >
          {/* Subtle header inside the mega menu */}
          <div className="mb-4 flex justify-between items-center border-b border-gray-100 pb-2">
            <h3 className="text-gray-900 font-bold text-lg">{isArabic ? 'اكتشف الفئات' : 'Discover Categories'}</h3>
            <Link to="/categories" className="text-sm font-semibold text-redLogo hover:text-red-700 transition-colors">
              {isArabic ? 'عرض الكل' : 'View All'} &rarr;
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-h-[50vh] overflow-y-auto pr-2 custom-scrollbar">
            {categories.map((category, index) => (
              <div key={`${category.id}-${index}`} className="mega-card flex flex-col h-40">
                <MegaMenuCard category={category} isArabic={isArabic} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MegaMenu;
